import { useMemo } from 'react'
import { useMproTokenContractAddress, useSwapRouterContractAddress } from 'state/global/hooks'
import { BASE_CHAIN_ID, MPRO_MASTER_DISTRIBUTOR } from './addresses'

export interface SwapContext {
  chainId: number
  /**
   * MPRO on Base, read from the platform's own contract configuration rather
   * than from a literal. A redeploy of the token changes a dashboard row, not
   * a release — the same reasoning the marketplace context is built on.
   */
  mproAddress: string | null
  /** Decides how much of an MPRO transfer is burned (§2.4). */
  masterDistributorAddress: string
  /**
   * The MPRO Lab swap router on Base (scope 16), from the contracts config.
   * Null when none is registered — the page then trades direct, with no fee.
   */
  routerAddress: string | null
}

export function useSwapContext(): SwapContext {
  const mproContracts = useMproTokenContractAddress()
  const routerContracts = useSwapRouterContractAddress()

  return useMemo(() => {
    const onBase = mproContracts.find((c) => c.chainId === BASE_CHAIN_ID && c.isActive)
    const router = routerContracts.find((c) => c.chainId === BASE_CHAIN_ID && c.isActive)
    return {
      chainId: BASE_CHAIN_ID,
      mproAddress: onBase?.address?.toLowerCase() ?? null,
      routerAddress: router?.address?.toLowerCase() ?? null,
      masterDistributorAddress:
        (import.meta.env.VITE_MASTER_DISTRIBUTOR_ADDRESS as string | undefined)?.toLowerCase() ||
        MPRO_MASTER_DISTRIBUTOR
    }
  }, [mproContracts, routerContracts])
}
